import React from 'react'
import { Card } from 'react-bootstrap'
import { DashboardUnit } from '@dataTypes/dashboard.types'
import { formatNumber } from '@utils/index'

type TodayCardProps = {
  dataId: string
  value: number | string
  unit: DashboardUnit
  patientCount: number | string
  cardConfig: any
}

function TodayCard({
  dataId,
  value,
  unit,
  cardConfig,
  patientCount,
}: TodayCardProps): React.ReactElement {
  const { title, icon, label } = cardConfig[dataId]
  const showCurrency = unit === 'currency' ? true : false
  const formattedValue = formatNumber(value, showCurrency)

  return (
    <Card className="border-start-lg border-start-primary-1 h-100">
      <Card.Body>
        <h5 className="fw-bolder">
          <i className={`${icon} me-2 fs-1`}></i>
          {title}
        </h5>
        <div className="mb-0">
          <span className="display-5 text-blue1 fw-semibold ">
            {formattedValue}
          </span>
          <span className="ms-2">{`${patientCount} ${label}`}</span>
        </div>
      </Card.Body>
    </Card>
  )
}

export default TodayCard
